const hasStatus = (error: unknown): error is { status: number | string } =>
  typeof error === 'object' && error !== null && 'status' in error;

/**
 * Русский текст ошибки дневника. Коды подтверждены бэкендом:
 * 409 — задание уже отправлено либо черновик существует, 422 — невалидный source.
 */
export const diaryErrorMessage = (error: unknown, action: 'save' | 'send' | 'recall'): string => {
  const status = hasStatus(error) ? error.status : null;

  switch (status) {
    case 409:
      if (action === 'send') return 'Задание по этой сессии уже отправлено клиенту';
      if (action === 'recall') return 'Задание больше нельзя отозвать — клиент уже начал его выполнять';
      return 'Черновик по этой сессии уже существует — обновите страницу';
    case 422:
      return 'Не удалось собрать задание: данные инструментов изменились. Обновите страницу и попробуйте снова';
    case 403:
      return 'Нет доступа к дневнику этого клиента';
    case 401:
      return 'Сессия истекла, войдите заново';
    default:
      if (action === 'send') return 'Не удалось отправить задание клиенту';
      if (action === 'recall') return 'Не удалось отозвать задание';
      return 'Не удалось сохранить черновик';
  }
};
